export default __webpack_public_path__ + "static/media/responsive1.3edf5e3f.svg";